import * as React from 'react';
import { Input } from '@cian/ui-kit';
import { useEventCallback } from '@cian/react-utils';
import { debounce } from 'throttle-debounce';
import { ISearchCatalogItem } from '../../../../../types/geo';
import * as styles from './LocationModalMobile.css';
import { IGeo } from '../../../../../store/geo';
import { getSuggestLinkText } from '../../../../filters/geo_textfield/getSuggestLinkText';
import { Modal, HEADER_HEIGHT } from '../../../../Modal';

export interface ILocationModalMobileProps {
  open: boolean;
  geo: IGeo;
  onClose(): void;
  onTextChange(value: string): void;
  onItemSelect(suggest: ISearchCatalogItem): void;
}

export const LocationModalMobile: React.FC<ILocationModalMobileProps> = ({
  open,
  geo,
  onClose,
  onTextChange,
  onItemSelect,
}) => {
  const [value, setValue] = React.useState('');

  // oxlint-disable-next-line react/exhaustive-deps
  const loadSuggests = React.useCallback(debounce(250, onTextChange), []);

  const handleValueChange = useEventCallback((_e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const query = value.trim();

    loadSuggests('');

    if (query) {
      loadSuggests(query);
    }

    setValue(value);
  });

  const handleItemSelect = useEventCallback((suggest: ISearchCatalogItem) => {
    setValue('');

    onItemSelect(suggest);
  });

  return (
    <Modal open={open} title="Введите регион или город" name="LocationModal" onClose={onClose}>
      <div className={styles['search']} style={{ top: HEADER_HEIGHT }}>
        <Input loading={geo.isAutocompleteLoading} placeholder="Поиск" value={value} onChange={handleValueChange} />
      </div>
      <div className={styles['results']}>
        <ul className={styles['list']} role="listbox">
          {geo.autocompleteSuggests.map(item => (
            <li
              role="option"
              tabIndex={0}
              className={styles['item']}
              key={`location-${item.displayName}`}
              onClick={() => handleItemSelect(item)}
            >
              {getSuggestLinkText(item.displayName, value.trim(), [], styles['item-text'])}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};
